import { render, staticRenderFns } from "./changeName.vue?vue&type=template&id=05da5709"
import script from "./changeName.vue?vue&type=script&lang=js"
export * from "./changeName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports